import { render, staticRenderFns } from "./PurchaseSuggestionWidget.vue?vue&type=template&id=03e75db1&"
import script from "./PurchaseSuggestionWidget.vue?vue&type=script&lang=js&"
export * from "./PurchaseSuggestionWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QSeparator,QSpinner,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtn,QSeparator,QSpinner,QTable})
